import { ProductDetailsBreadcrumbs } from "./ProductDetailsBreadcrumbs";
import { ProductDetailsCarousel } from "./ProductDetailsCarousel";
import ProductDetailsGallery from "./ProductDetailsGallery";
import { ProductDetailsListingPagesChips } from "./ProductDetailsListingPagesChips";
import { ProductDetailsLoading } from "./ProductDetailsLoading";
import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { ProductDetailsSellerBlock } from "@/components/ProductDetail/ProductDetailsSellerBlock";
import { ProductDetailsTrustpilot } from "@/components/ProductDetail/ProductDetailsTrustpilot";
import { ProductDetailsFavoriteItems } from "@whoppah/components/ProductDetail/ProductDetailsFavoriteItems";
import { ProductDetailsSimilarItems } from "@whoppah/components/ProductDetail/ProductDetailsSimilarItems";
import { ProductDetailsInfo } from "@whoppah/components/ProductDetail/info/ProductDetailsInfo";

type ProductDetailsBradcrumbsDelegatorProps = {
  product: ProductBySlugNonNullable;
  loading?: boolean;
};

const ProductDetailsBradcrumbsDelegator = ({
  product,
  loading,
}: ProductDetailsBradcrumbsDelegatorProps) => {
  if (loading) {
    return <span className="skeleton" />;
  }

  return <ProductDetailsBreadcrumbs product={product} />;
};

type ProductDetailsDelegatorProps = {
  product: ProductBySlugNonNullable;
  loading?: boolean;
};

const ProductDetailsDelegator = ({
  product,
  loading,
}: ProductDetailsDelegatorProps) => {
  if (loading) {
    return <ProductDetailsLoading />;
  }

  return (
    <>
      <div className="-mb-8 md:col-span-2 md:-mb-0">
        <ProductDetailsCarousel product={product} className="md:hidden" />
        <ProductDetailsGallery
          product={product}
          className="sticky top-4 hidden max-h-min gap-4 md:grid md:grid-cols-2"
        />
      </div>
      <div>
        <div className="top-4 flex flex-col space-y-4 md:sticky">
          <ProductDetailsInfo product={product} />
        </div>
      </div>
      <hr className="md:col-span-3" />
      <ProductDetailsListingPagesChips product={product} />
      <ProductDetailsSimilarItems product={product} className="md:col-span-3" />
      <ProductDetailsFavoriteItems className="w-full md:col-span-3" />
      <hr className="md:col-span-3" />
      <ProductDetailsSellerBlock product={product} />
      <ProductDetailsTrustpilot />
    </>
  );
};

type ProductDetailsProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetails = ({ product }: ProductDetailsProps) => {
  const isLoading = !product;

  return (
    <div
      data-testid="pdp.root"
      className="my-2 flex flex-col gap-4 px-3 md:my-4 md:px-12 xl:px-24"
    >
      <ProductDetailsBradcrumbsDelegator
        product={product}
        loading={isLoading}
      />
      <div className="mb-4 grid grid-cols-1 gap-8 md:mb-10 md:grid-cols-3">
        <ProductDetailsDelegator product={product} loading={isLoading} />
      </div>
    </div>
  );
};
